import { render, staticRenderFns } from "./AthleteEventsCard.vue?vue&type=template&id=3913fbb0&scoped=true&"
import script from "./AthleteEventsCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteEventsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3913fbb0",
  null
  
)

export default component.exports